import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './_services';
import { User, Role } from './_models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // title = 'a-z';
  
  // showHead: boolean = false;
  currentUser: User;

  ngOnInit() {}

  constructor(private router: Router ,private authenticationService: AuthenticationService) {
  // on route change to '/admin-auth', set the variable showHead to false
    // router.events.forEach((event) => {
    //   if (event instanceof NavigationStart) {
    //     if (event['url'] == ('/admin-auth')) {
    //       this.showHead = false;
    //     }
    //     else if(event['url']==('/admin-auth/Signup'))
    //     {
    //       this.showHead=false;
    //     } 
    //     else if(event['url']==('/admin-auth/forgot-password'))
    //     {
    //       this.showHead=false;
    //     } 
    //     else {
    //       // console.log("NU")
    //       this.showHead = true;
    //     }
    //   }
    // });

    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);   
  }

  get isAdmin() {
    console.log("Role is: "+this.currentUser.admin.role);
    return this.currentUser && this.currentUser.admin.role === Role.Admin;
}


}
